import { Component } from "@angular/core";

@Component({
  selector: "svg-definitions",
  templateUrl: "./svg-definitions.component.html"
})
export class SvgDefinitionsComponent {

}
